import {CO2_INTERVENTION_TYPE} from '../config';

export const hasCuttingWithoutExtractedMass = (allCO2Interventions) => allCO2Interventions
  .filter(co2Intervention => co2Intervention.co2InterventionType === CO2_INTERVENTION_TYPE.FINAL_CUTTINGS ||
      co2Intervention.co2InterventionType === CO2_INTERVENTION_TYPE.INTERMEDIATE_CUTTINGS)
  .some(cuttingIntervention => cuttingIntervention.extracted_volume === 0);